"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immer_1 = require("immer");
function setDeliveryTypeMenuPrice(item, deliveryType) {
    return immer_1.produce(item, (item) => {
        var _a;
        if (deliveryType === 'table') {
            return;
        }
        if (deliveryType === 'storeDelivery') {
            deliveryType = 'takeaway';
        }
        const deliveryTypePrice = (_a = item.prices) === null || _a === void 0 ? void 0 : _a.find(price => price.type === deliveryType);
        if (deliveryTypePrice != null) {
            item.price = deliveryTypePrice.price;
            item.discount = deliveryTypePrice.discount;
            item.priceUndetermined = false;
            return;
        }
        if (item.priceUndetermined) {
            item.takeawayDisabled = true;
        }
    });
}
exports.default = setDeliveryTypeMenuPrice;
//# sourceMappingURL=setDeliveryTypeMenuPrice.js.map